// extracted by mini-css-extract-plugin
module.exports = {"singlePill":"_1I7B_AXd","pillTextWrapper":"_3OaSHkXP","pillType":"_2pknuPkL","capitalize":"KW__xIdo","pillText":"Bkl1k4Lq"};